import { Component, OnInit } from '@angular/core';
import { ApiOpenmindService } from '../apiopenmind.service';
import { Router } from '@angular/router';

export interface userTable {
  id: number;
  names: string;
  lastNames: string;
  email: string;
}

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit {

  public dataSource: userTable[] = [];
  public displayedColumns = ["id", "names", "lastNames", "email", "actions"];
  public userId: string;
  public resourcesLoaded: any[] = [];

  constructor(private apiOpenmind: ApiOpenmindService, private router: Router) {
    //let user = JSON.parse(sessionStorage.getItem("loginData")).userResponse;
    this.userId = "1";//user.userid;
  }

  ngOnInit() {
    //renderRows()
    this.apiOpenmind.GetUsers().toPromise().then(x => this.dataSource = x.map(val => <userTable>{
      id: val.userid,
      names: val.username,
      lastNames: val.lastname,
      email: val.email
    }));

  }

  createUser() {
    this.router.navigate(['/user-detail']);
  }

  createUsers() {
    this.router.navigate(['/user-detail']);
  }

  updateUser(id) {
    sessionStorage.setItem("userEditId", id);
    this.router.navigate(['/user-detail']);
  }
}
